import * as React from 'react';
import { Toaster as Sonner } from 'sonner';

import { cn } from '../../lib/utils';
import { Z_TOAST } from '../../lib/z-index';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const TOASTER_LAYER_Z_INDEX = Z_TOAST;

const Toaster = ({ className, style, ...props }: ToasterProps) => {
  return (
    <Sonner
      className={cn('toaster group', className)}
      style={{ zIndex: TOASTER_LAYER_Z_INDEX, ...style }}
      toastOptions={{
        classNames: {
          toast:
            'group toast relative !pointer-events-auto !max-w-[calc(100vw-2rem)] !rounded-xl !border !border-border ' +
            '!bg-secondary !px-4 !py-3 !shadow-[0_18px_40px_-20px_rgba(0,0,0,0.85)] !ring-1 !ring-primary/20 ' +
            'data-[type=success]:!border-success data-[type=success]:!ring-success/20 ' +
            'data-[type=error]:!border-destructive data-[type=error]:!ring-destructive/20 ' +
            'data-[type=warning]:!border-warning data-[type=warning]:!ring-warning/20 ' +
            'data-[type=info]:!border-info data-[type=info]:!ring-info/20',
          title:
            '![font-family:var(--font-benzin)] !text-[11px] !uppercase !tracking-[0.22em] !leading-[1.1] !text-foreground',
          description:
            '![font-family:var(--font-sans)] !mt-1 !text-xs !leading-snug !text-muted-foreground',
          actionButton:
            '![font-family:var(--font-sans)] !h-[38px] !rounded-md !bg-accent !px-3 !text-[10px] !text-accent-foreground ' +
            'hover:!opacity-90 focus-visible:!outline-none focus-visible:!ring-2 focus-visible:!ring-ring focus-visible:!ring-offset-2 ' +
            'focus-visible:!ring-offset-secondary',
          cancelButton:
            '![font-family:var(--font-sans)] !h-[38px] !rounded-md !border !border-border !bg-transparent !px-3 !text-[10px] !text-foreground ' +
            'hover:!bg-muted focus-visible:!outline-none focus-visible:!ring-2 focus-visible:!ring-ring focus-visible:!ring-offset-2 ' +
            'focus-visible:!ring-offset-secondary',
          closeButton:
            '!absolute !right-2 !top-2 !rounded-md !p-1 !text-muted-foreground hover:!bg-muted hover:!text-foreground ' +
            'focus-visible:!outline-none focus-visible:!ring-2 focus-visible:!ring-ring focus-visible:!ring-offset-2 focus-visible:!ring-offset-secondary',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
